var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M71.7,228.4l86.6-86.6L71.7,55.1l26.7-26.7l113.4,113.4L98.4,255.1L71.7,228.4z"}));
}

ArrowRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
